var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MusicList',{ref:"musicList",staticClass:"music_list",attrs:{"list":_vm.list,"finished":_vm.finished,"playing":_vm.playing,"currentIndex":_vm.currentIndex},on:{"loadMore":_vm.handleLoadMore,"clickMusic":_vm.handleMusicAction,"action":_vm.handleClickAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }